import {
  Lit3formBlock,
  html,
  ifDefined,
  unsafeHTML,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class Enrique extends Lit3formBlock {
  static get characterName() {
    return 'enrique';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid enrique-layout">
          <h3 class="block-header">${unsafeHTML(this.headerText)}</h3>
          <div class="images">
            ${this.imagesArr.map(i => {
              const image = i[1];
              return html`
                <a
                  class="image-wrapper"
                  @click=${e => this.imageClicked(image, e)}
                  href=${ifDefined(image.url)}
                >
                  <div class="img-container">
                    <img src=${this.imageSrc(image)} />
                  </div>
                  ${this.cardTextHTML(image)}
                  <cta-text cta-data=${this.ctaData(image)}></cta-text>
                </a>
              `;
            })}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageSrc(image) {
    return this.imagebossUrl(image.src, null, 400);
  }

  // With the event, handleAdobeNavEvent holds the link and navigates once;
  // without it the browser and the delayed redirect both navigated.
  imageClicked(image, event) {
    if (this.richTextLinkClicked(event) || !image.url) return;

    handleAdobeNavEvent({
      analyticsCtaDataObject: analyticsCtaDataObject(image, this.headerText),
      destinationUrl: image.url,
      event,
    });
  }

  cardTextHTML(image) {
    return image.title || image.description
      ? html`
          <div>
            ${this.titleHTML(image)}${this.descriptionHTML(image)}
          </div>
        `
      : html``;
  }

  titleHTML(image) {
    return image.title
      ? html`
          <h4>
            ${unsafeHTML(this.withLineBreaks(image.title))}
          </h4>
        `
      : html``;
  }

  descriptionHTML(image) {
    return image.description
      ? html`
          <p class="description">
            ${unsafeHTML(this.withLineBreaks(image.description))}
          </p>
        `
      : html``;
  }

  ctaData(image) {
    if (!image.text) return '';
    return JSON.stringify({
      text: `${image.text || ''}`,
      url: `${image.url || ''}`,
    });
  }
}
Enrique.defineElement();
